export default __webpack_public_path__ + "static/card-3-8b442074a22f7d67043c28d6b31f987d.png";